import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const Countdown = ({ deadline }) => {
    const now = new Date(),
        deadlineArr = deadline.split(/[- : T]/).map((datePiece) => parseInt(datePiece, 10)),
        endDate = new Date(deadlineArr[0], deadlineArr[1]-1, deadlineArr[2], deadlineArr[3], deadlineArr[4], deadlineArr[5]).getTime(),
        t = endDate - now,
        hoursLeft = Math.floor((t/(1000*60*60)) % 24),
        daysLeft = Math.floor(t/(1000*60*60*24));

    return (<span className="countdown"><i className="fa fa-clock-o"></i> {`${daysLeft}d ${hoursLeft}h`}</span>);
};

Countdown.propTypes = {
    deadline: PropTypes.string
};

export default Countdown;



// WEBPACK FOOTER //
// ./src/shared/countdown/index.js